export default __webpack_public_path__ + "static/media/camera.5bfbbf8c.svg";